import { CircularProgress, Typography, TypographyProps } from '@mui/material';
import React, { useEffect, useState } from 'react';

import { getSavingState } from '../../store/V2/SavingSlice';
import { useAppSelector } from '../../hooks';

export interface SavingStateViewerProps {
  componentProps?: TypographyProps;
}

const SavingStateViewer: React.FC<SavingStateViewerProps> = ({
  componentProps = {},
}) => {
  // Store
  const savingState = useAppSelector(getSavingState);

  // State
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (savingState.status === 'loading') {
      setVisible(true);
    } else {
      setTimeout(() => {
        setVisible(false);
      }, 5000);
    }
  }, [savingState.status]);

  const Container = ({ children }) => {
    return (
      <Typography
        display="flex"
        alignItems="center"
        gap="5px"
        {...componentProps}
      >
        {children}
      </Typography>
    );
  };

  if (!visible) {
    return null;
  }

  if (savingState.status === 'loading') {
    return (
      <Container>
        <CircularProgress size={15} /> Saving
      </Container>
    );
  }

  if (savingState.status === 'idle') {
    return <Container>Saved</Container>;
  }

  return null;
};

export default SavingStateViewer;
